import qs from 'qs';
import { AttendeeUser, AttendeesResponse, LoadAttendeesParams } from '@/types/all-attendees.types';
import { Get } from '../helpers';
import { RegFieldsEnum } from '@/types/registration.types';

export default function LoadAttendees<T = AttendeeUser>({
  channel,
  eventUuid,
  page = 0,
  pageSize = '25',
  search,
  sort,
  sortDirection,
  fields,
  status,
  registrationStatusFilter,
  passcodeListId,
  signal,
}: LoadAttendeesParams): Promise<AttendeesResponse<T>> {
  // Always include first name (1) and last name (2) in the profile fields —
  // needed to add users to a passcode list.
  const profileFields = [...new Set([...(fields?.profile ?? []), RegFieldsEnum.first_name, RegFieldsEnum.last_name])];

  const query = qs.stringify(
    {
      page,
      pageSize,
      ...(search && { search }),
      ...(sort && { sort }),
      ...(sortDirection && { direction: sortDirection }),
      ...(status && { status }),
      ...(passcodeListId && { audienceLists: String(passcodeListId) }),
      ...(registrationStatusFilter &&
        registrationStatusFilter !== 'all' && { registrationStatus: registrationStatusFilter }),
      fields: {
        ...(profileFields.length && { profile: profileFields }),
        ...(fields?.location?.length && { location: fields.location }),
        ...(fields?.stats?.length && { stats: fields.stats }),
        ...(fields?.event_data?.length && { event_data: fields.event_data }),
      },
    },
    { arrayFormat: 'brackets' }
  );

  return Get<AttendeesResponse<T>>({
    url: `/v4/admin/attendees/${channel}/${eventUuid}?${query}`,
    signal,
  });
}
